import {createFileRoute, redirect} from '@tanstack/react-router';
import {Navbar} from '@/components/ui/navbar';
import {BlogPostForm} from '@/components/adminBlog/blogPostForm';

export const Route = createFileRoute('/admin/blog-create')({
  component: AdminBlogCreatePage,
  beforeLoad: ({context, location}) => {
    if (!context.profile) {
      throw redirect({
        to: '/login',
        search: {redirect: location.href},
      });
    }
    if (context.profile.level !== 'superadmin') {
      throw redirect({to: '/'});
    }
  },
});

/** Standalone full-width page for creating a blog post. */
function AdminBlogCreatePage() {
  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <div className="flex-1 min-h-0 flex flex-col pt-6 px-6">
        <BlogPostForm />
      </div>
    </div>
  );
}
